import React from 'react';
import './Team.css';
import teamHero from '../images/team-hero.jpg';
import Header from "../Header/Header"
import HeroSection from '../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Slider from "react-slick";
import Footer from '../Footer/Footer';
import axios from 'axios';
import BigTeam from './BigTeam/BigTeam';
import SmallTeam from './SmallTeam/SmallTeam';
import ReactGA from 'react-ga';
class Team extends React.Component{
    state = {
        moobiteam: [],
        we: true,
    }
    componentDidMount() {
        axios.get(`/moobifunapi/v1/teams?language=en`)
            .then(response => {
                this.setState({
                    moobiteam: response.data.teams,
                    we: false
                });
            })
        .catch(function (error) {
            console.log(error);
        });
        ReactGA.pageview('/team');
    }
    render() {
        window.scrollTo(0, 0);
        const BigTeams = this.state.moobiteam.map(bigTeam => {
            if (bigTeam.level === 1) {
                return <BigTeam name={bigTeam.name} position={bigTeam.position} key={"team "+bigTeam.id}
                    picture = {bigTeam.imageLocation + bigTeam.imageName}
                />
            } 
            
        });
        const SmallTeams = this.state.moobiteam.map(team => {
            if (team.level !== 1) {
                return <SmallTeam name={team.name} position={team.position} key={"team "+team.id}
                     picture = {team.imageLocation + team.imageName}
                />
            } 
        });
        let loader = <div className="loader-container">
            <i className="fa fa-spinner fa-spin"></i>
        </div> 
       return (
        <div className="team-page">
            <Header />
            <HeroSection background={teamHero} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/team" className="current">Team</Link></li>
                    </ul>
                </Container>
                <div className="teams">
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span> Our Team </span><i className="fa fa-circle"></i></h2>
                    <Container>
						<img src={require('./uc.jpg')} alt="Under construction" />
                    </Container>
                </div>
            </section>
            <Footer />
        </div>
       );
    }
}
export default Team;
